import { render } from "./gsrbr020401.vue?vue&type=template&id=760bacda&scoped=true"
import script from "./gsrbr020401.vue?vue&type=script&lang=js"
export * from "./gsrbr020401.vue?vue&type=script&lang=js"

import "./gsrbr020401.vue?vue&type=style&index=0&id=760bacda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760bacda"]])

export default __exports__